import {createReducer} from '@reduxjs/toolkit';

import {
  setDefaultMembershipCardAction,
  setMembershipCardsAction,
  setVoucherDataAction,
  setCurrentStoreAction,
  setStoreAreasAction,
  setIsDirectCheckoutAction,
  setAccessTradeClickIdAction,
  setPricezaClickIdAction,
  setIsAppLoadingAction,
  setAppModeAction,
  setAppVersionAction,
  setDeviceOSAction,
  resetStateAction
} from 'store/actions/app-action';
import {AppMode, AppState} from 'store/types/app';

const initialState: AppState = {
  defaultMembershipCard: undefined,
  membershipCards: [],
  voucherData: undefined,
  currentStore: undefined,
  locations: null,
  isDirectCheckout: false,
  accessTradeClickId: undefined,
  pricezaClickId: undefined,
  isAppLoading: false,
  appMode: AppMode.regular,
  appVersion: undefined,
  deviceOS: undefined,
  resetEffectValue: 0
};

const AppReducer = createReducer(initialState, (builder) => {
  builder.addCase(setDefaultMembershipCardAction, (state, action) => {
    return {
      ...state,
      defaultMembershipCard: action.payload
    };
  });

  builder.addCase(setMembershipCardsAction, (state, action) => {
    return {
      ...state,
      membershipCards: action.payload
    };
  });

  builder.addCase(setVoucherDataAction, (state, action) => {
    return {
      ...state,
      voucherData: action.payload
    };
  });

  builder.addCase(setCurrentStoreAction, (state, action) => {
    return {
      ...state,
      currentStore: action?.payload
    };
  });

  builder.addCase(setStoreAreasAction, (state, action) => {
    return {
      ...state,
      locations: action?.payload
    };
  });

  builder.addCase(setIsDirectCheckoutAction, (state, action) => {
    return {
      ...state,
      isDirectCheckout: action?.payload
    };
  });

  builder.addCase(setAccessTradeClickIdAction, (state, action) => {
    return {
      ...state,
      accessTradeClickId: action?.payload
    };
  });

  builder.addCase(setPricezaClickIdAction, (state, action) => {
    return {
      ...state,
      pricezaClickId: action?.payload
    };
  });

  builder.addCase(setIsAppLoadingAction, (state, action) => {
    return {
      ...state,
      isAppLoading: action?.payload
    };
  });
  builder.addCase(setAppModeAction, (state, action) => {
    return {
      ...state,
      appMode: action?.payload
    };
  });
  builder.addCase(setAppVersionAction, (state, action) => {
    return {
      ...state,
      appVersion: action?.payload
    };
  });
  builder.addCase(setDeviceOSAction, (state, action) => {
    return {
      ...state,
      deviceOS: action?.payload
    };
  });
  builder.addCase(resetStateAction, (state) => {
    const resetEffectValue = Math.random();
    return {
      ...state,
      resetEffectValue
    };
  });
});

export default AppReducer;
